var SvcsScreenOther = (function ($) {

    SvcsScreenOther = function (options) {
        var that = this;

        that.class = {
            svcs_other_total_drawer_call: 'js-other-total-call',
            svcs_other_total_content: 'js-svcs-other-total-content',
            svcs_other_total_segment: 'js-side-total-segment',
            svcs_other_total_item: 'js-side-total-item',
            svcs_other_total_item_count: 'js-side-total-item-count',
            svcs_other_total_item_amount: 'js-side-total-item-amount',
            svcs_other_total_amount: 'js-side-total-amount',

            svc_card_wrapper: 'js-svc-card-wrapper',
            svc_type_card: 'js-svc-type-card',
            svc_action: 'js-svc-action',
            svc_action_add: 'js-svc-action-add',
            svc_action_edit: 'js-svc-action-edit',

            svc_badge_added: 'js-svc-badge-added',
            svc_badge_added_quantity: 'js-svc-badge-added-quantity',

            svc_badge_paid: 'js-svc-badge-paid',
            svc_badge_paid_quantity: 'js-svc-badge-paid-quantity',

            svcs_ife_movies_drawer_call: 'js-ife_movies-drawer-call',
            svcs_ife_movies_html: 'js-drawer-ife-movies-html',
            
            svcs_meal_drawer_call: 'js-meal-drawer-call',
            svcs_meal_html: 'js-drawer-meal-html',

            svcs_insurance_drawer_call: 'js-insurance-drawer-call',
            svcs_insurance_html: 'js-drawer-insurance-html',

            svcs_notice_drawer_call: 'js-notice-drawer-call',
            svcs_notice_html: 'js-drawer-notice-html'
        };

        that.$wrapper = options['$wrapper'];
        that.analytics_dataset = options.analytics_dataset || null;

        if (that.$wrapper && that.$wrapper.length) {
            // DOM
            that.modals = options['modals'];

            // CONST
            that.order_currency = options['order_currency'] || '';
            that.order_segments_ids = options.order_segments_ids;
            that.order_passengers_ids = options.order_passengers_ids;

            that.SVC_TYPES = {
                ife_movies: 'ife_movies',
                meal: 'meal',
                insurance: 'insurance',
                notice: 'notice'
            };
            
            that.meal_incomplete_warning_enable = options['meal_incomplete_warning_enable'];
            that.meal_incomplete_warning_html = that.modals['meal_incomplete_warning_html'];

            // DYNAMIC VARS
            that.ife_movies_items_unpaid = options['ife_movies_items_unpaid'] || [];
            that.ife_movies_items_paid = options['ife_movies_items_paid'] || [];
            that.ife_movies_items_default = options['ife_movies_items_default'] || [];
            that.ife_movies_need_force_select = true;
            
            that.meal_items_unpaid = options['meal_items_unpaid'] || [];
            that.meal_items_paid = options['meal_items_paid'] || [];
            that.meal_items_default = options['meal_items_default'] || [];

            that.insurance = new SvcsScreenOtherInsurance({
                $wrapper: $.sa.$document.find('.' + that.class.svcs_insurance_html),
                analytics_dataset: that.analytics_dataset,
                order_currency: that.order_currency
            });
            that.insurance_items_unpaid = options['insurance_items_unpaid'] || [];
            that.insurance_items_paid = options['insurance_items_paid'] || [];
            that.insurance_items_default = options['insurance_items_default'] || [];
            that.insurance_need_force_select = true;
            that.insurance_empty_warning_enable =  options['insurance_incomplete_warning_enable'];
            that.insurance_empty_warning_shown = false;
            that.insurance_empty_warning_html = that.modals['insurance_empty_warning_html'];
            /** @type {InsuranceSelection|null} */
            that.insurance_selection = that.__getInsuranceSelection();

            that.notice_items_unpaid = options['notice_items_unpaid'] || [];
            that.notice_items_paid = options['notice_items_paid'] || [];
            that.notice_items_default = options['notice_items_default'] || [];
            that.notice_need_force_select = true;

            that.is_showed = false;

            that.total = options['total'] || 0;

            // HANDLERS
            that.onSvcSelected = (options['onSvcSelected'] || function () {
            });
            that.onSvcReset = (options['onSvcReset'] || function () {
            });
            that.onInsuranceEmptyWarningClose = (options['onInsuranceEmptyWarningClose'] || function () {
            });

            // INIT
            that.init();
        }
    }

    SvcsScreenOther.prototype.init = function () {
        var that = this;

        //
        that.svcOtherTotalDrawerInit();
        //
        that.__svcBadgeToggle('added', false);
        //
        that.__svcBadgeToggle('paid', false);
        //
        // set action button state empty
        that.__svcTypeSetActionStateAdd();
        //
        that.svcIfeMoviesDrawerHandler();
        //
        that.svcMealDrawerHandler();
        //
        that.svcInsuranceDrawerHandler();
        //
        that.svcNoticeDrawerHandler();

        // if there are initially selected unpaid items
        if (
            that.ife_movies_items_unpaid.length ||
            that.meal_items_unpaid.length ||
            that.insurance_items_unpaid.length ||
            that.notice_items_unpaid.length
        ) {
            that.__showInitialSvcsUnpaid();
        }

        // if there is no initially selected unpaid items - 
        // just display default svcs total on Show
        else {
            that.__displayTotal();
        }
    };

    SvcsScreenOther.prototype.onShow = function () {
        var that = this;

        // if there are initially default items,
        // they are shown only on Screen open event (onShow)
        if (
            !that.is_showed &&
            (
                that.ife_movies_items_default.length ||
                that.meal_items_default.length ||
                that.insurance_items_default.length ||
                that.notice_items_default.length
            )
        ) {
            that.__showInitialSvcsDefault();
        }
        // if there is no initially selected default items - 
        // just display default svcs total on Show
        else {
            that.__displayTotal();
        }

        if (that.analytics_dataset && that.analytics_dataset.layout === 'main') {
            $.sa.analytics.gtagSelectContent('page', 'main_other_svcs');
        }

        that.is_showed = true;

        if (that.insurance_selection) {
            that.insurance_selection.init();
        }
    };

    SvcsScreenOther.prototype.__showInitialSvcsUnpaid = function () {
        var that = this;

        var showSvcs = function (svcs_collection, svc_type) {
            // perform functions called after selection and collection changes
            // (don't need to call __saveSvcInCollection() - these items are already in collection)
            that.__afterCollectionChanged(svcs_collection, svc_type);

            svcs_collection.forEach(function (svc) {
                var svc_quantity = svc.item_quantity ? parseInt(svc.item_quantity, 10) : 0;
                // add item_quantity_diff into svc data - equals svc quantity
                that.__afterSvcSelect(Object.assign({}, svc, {item_quantity_diff: svc_quantity}));
            });
        };

        if (that.ife_movies_items_unpaid.length) {
            showSvcs(that.ife_movies_items_unpaid, that.SVC_TYPES.ife_movies);
        }

        if (that.meal_items_unpaid.length) {
            showSvcs(that.meal_items_unpaid, that.SVC_TYPES.meal);
        }

        if (that.insurance_items_unpaid.length) {
            showSvcs(that.insurance_items_unpaid, that.SVC_TYPES.insurance);
        }

        if (that.notice_items_unpaid.length) {
            showSvcs(that.notice_items_unpaid, that.SVC_TYPES.notice);
        }
    };

    SvcsScreenOther.prototype.__showInitialSvcsDefault = function () {
        var that = this;

        var showSvcs = function (svcs_collection, svc_type) {
            // perform functions called after selection and collection changes
            // (don't need to call __saveSvcInCollection() - these items are already in collection)
            that.__afterCollectionChanged(svcs_collection, svc_type);

            svcs_collection.forEach(function (svc) {
                var svc_quantity = svc.item_quantity ? parseInt(svc.item_quantity, 10) : 0;
                // add item_quantity_diff into svc data - equals svc quantity
                that.__afterSvcSelect(Object.assign({}, svc, {item_quantity_diff: svc_quantity}));
            });
        };

        if (that.ife_movies_items_default.length) {
            showSvcs(that.ife_movies_items_default, that.SVC_TYPES.ife_movies);
        }
     
        if (that.meal_items_default.length) {
            showSvcs(that.meal_items_default, that.SVC_TYPES.meal);
        }
     
        if (that.insurance_items_default.length) {
            showSvcs(that.insurance_items_default, that.SVC_TYPES.insurance);
        }

        if (that.notice_items_default.length) {
            showSvcs(that.notice_items_default, that.SVC_TYPES.notice);
        }
    };

    SvcsScreenOther.prototype.svcOtherTotalDrawerInit = function () {
        var that = this,
            $action = that.$wrapper.find('.' + that.class.svcs_other_total_drawer_call);

        $action.on('click', function (e){
            e.preventDefault();

            var content = that.$wrapper.find('.' + that.class.svcs_other_total_content).html(),
                title = $action.data('title');

            $.uiDrawer({
                position: 'bottom',
                header_title: title,
                content: content,
                custom_class: 'svcs-other',
                fluid: true,
                disable_content_scroll: true
            });
        });
    };

    SvcsScreenOther.prototype.svcIfeMoviesDrawerHandler = function () {
        var that = this,
            $action = that.$wrapper.find(`.${that.class.svcs_ife_movies_drawer_call}`);

        $action.on('click', function (e){
            e.preventDefault();

            var html = that.$wrapper.find(`.${that.class.svcs_ife_movies_html}`).html();

            // Merge unpaid and default items (without overriding)
            var ife_movies_items_unpaid = that.__mergeIntoCollection(that.ife_movies_items_unpaid, that.ife_movies_items_default);
            // Save into unpaid
            that.ife_movies_items_unpaid = ife_movies_items_unpaid.slice();

            $.uiDrawer({
                html: html,
                onOpen: function ($wrapper, drawer) {
                    new SvcsScreenOtherIfeMovies({
                        $wrapper: $wrapper,
                        items_unpaid: that.ife_movies_items_unpaid,
                        items_paid: that.ife_movies_items_paid,
                        need_force_select: that.ife_movies_need_force_select,
                        order_currency: that.order_currency,
                        onButtonConfirmClick: function (data, component, event) {
                            data.forEach(function (data_item) {
                                that.__saveSvcInCollection(that.ife_movies_items_unpaid, data_item);
                            });
                            that.__afterCollectionChanged(that.ife_movies_items_unpaid, that.SVC_TYPES.ife_movies);
                        },
                        onButtonCancelClick: function (data, component, event) {
                            data.forEach(function (data_item) {
                                that.__resetSvcInCollection(that.ife_movies_items_unpaid, data_item);
                            });
                            that.__afterCollectionChanged(that.ife_movies_items_unpaid, that.SVC_TYPES.ife_movies);
                        }
                    });
                    if (that.analytics_dataset && that.analytics_dataset.layout === 'main') {
                        var analytics_event_data = that.analytics_dataset.getViewItemListForType('ife_movies');
                        if (analytics_event_data) {
                            $.sa.analytics.gtag('event', 'view_item_list', analytics_event_data);
                        }
                    }
                }
            });
        });
    };

    SvcsScreenOther.prototype.svcMealDrawerHandler = function () {
        var that = this,
            $action = that.$wrapper.find(`.${that.class.svcs_meal_drawer_call}`);

        $action.on('click', function (e){
            e.preventDefault();

            var html = that.$wrapper.find(`.${that.class.svcs_meal_html}`).html();

            // Merge unpaid and default items (without overriding)
            var meal_items_unpaid = that.__mergeIntoCollection(that.meal_items_unpaid, that.meal_items_default);
            // Save into unpaid
            that.meal_items_unpaid = meal_items_unpaid.slice();

            $.uiDrawer({
                html: html,
                onOpen: function ($wrapper, drawer){
                    new SvcsScreenOtherMeal({
                        $wrapper: $wrapper,
                        items_unpaid: that.meal_items_unpaid,
                        order_currency: that.order_currency,
                        analytics_dataset: that.analytics_dataset,
                        onButtonConfirmClick: function (data, component, event) {
                            data.forEach(function (data_item) {
                                that.__saveSvcInCollection(that.meal_items_unpaid, data_item);
                            });
                            that.__afterCollectionChanged(that.meal_items_unpaid, that.SVC_TYPES.meal);
                            
                            if (that.meal_incomplete_warning_enable) {
                                that.__initMealIncompleteWarning(drawer);
                            } else {
                                drawer.close();
                            }
                        },
                        onButtonCancelClick: function (data, component, event) {
                            data.forEach(function (data_item) {
                                that.__resetSvcInCollection(that.meal_items_unpaid, data_item);
                            });
                            that.__afterCollectionChanged(that.meal_items_unpaid, that.SVC_TYPES.meal);
                            drawer.close();
                        }
                    });
                }
            });
        });
    };

    SvcsScreenOther.prototype.svcInsuranceDrawerHandler = function () {
        var that = this,
            $action = that.$wrapper.find(`.${that.class.svcs_insurance_drawer_call}`);

        $action.on('click', function (e){
            e.preventDefault();

            var html = that.$wrapper.find(`.${that.class.svcs_insurance_html}`).html();

            // Merge unpaid and default items (without overriding)
            var insurance_items_unpaid = that.__mergeIntoCollection(that.insurance_items_unpaid, that.insurance_items_default);
            // Save into unpaid
            that.insurance_items_unpaid = insurance_items_unpaid.slice();
            
            $.uiDrawer({
                html: html,
                onOpen: function ($wrapper) {
                    that.insurance = new SvcsScreenOtherInsurance({
                        $wrapper: $wrapper,
                        modals: that.modals,
                        items_unpaid: that.insurance_items_unpaid,
                        need_force_select: that.insurance_need_force_select,
                        analytics_dataset: that.analytics_dataset,
                        order_currency: that.order_currency,
                        onButtonConfirmClick: function (data, component, event) {
                            data.forEach(function (data_item) {
                                that.__saveSvcInCollection(that.insurance_items_unpaid, data_item);
                            });
                            that.__afterCollectionChanged(that.insurance_items_unpaid, that.SVC_TYPES.insurance);
                        },
                        onButtonCancelClick: function (data, component, event) {
                            data.forEach(function (data_item) {
                                that.__resetSvcInCollection(that.insurance_items_unpaid, data_item);
                            });
                            that.__afterCollectionChanged(that.insurance_items_unpaid, that.SVC_TYPES.insurance);
                        },
                        onPassengerSelected: function (data, component) {
                            // SELECT SVC ON TOGGLE CARD BUTTON CLICK (https://tracker.flysa.ru/browse/SMA-2290)
                            if (data.hasOwnProperty('force_select')) {
                                that.insurance_need_force_select = !data.force_select;
                            }
                        }
                    });
                    if (that.analytics_dataset && that.analytics_dataset.layout === 'main') {
                        var analytics_event_data = that.analytics_dataset.getViewItemListForType('insurance');
                        if (analytics_event_data) {
                            $.sa.analytics.gtag('event', 'view_item_list', analytics_event_data);
                        }
                    }
                }
            });
        });
    };

    SvcsScreenOther.prototype.svcNoticeDrawerHandler = function () {
        var that = this,
            $action = that.$wrapper.find(`.${that.class.svcs_notice_drawer_call}`);

        $action.on('click', function (e) {
            e.preventDefault();

            var html = that.$wrapper.find(`.${that.class.svcs_notice_html}`).html();

            // Merge unpaid and default items (without overriding)
            var notice_items_unpaid = that.__mergeIntoCollection(that.notice_items_unpaid, that.notice_items_default);
            // Save into unpaid
            that.notice_items_unpaid = notice_items_unpaid.slice();

            $.uiDrawer({
                html: html,
                onOpen: function ($wrapper) {
                    new SvcsScreenOtherNotice({
                        $wrapper: $wrapper,
                        items_unpaid: that.notice_items_unpaid,
                        need_force_select: that.notice_need_force_select,
                        order_currency: that.order_currency,
                        onButtonConfirmClick: function (data, component, event) {
                            data.forEach(function (data_item) {
                                that.__saveSvcInCollection(that.notice_items_unpaid, data_item);
                            });
                            that.__afterCollectionChanged(that.notice_items_unpaid, that.SVC_TYPES.notice);
                        },
                        onButtonCancelClick: function (data, component, event) {
                            data.forEach(function (data_item) {
                                that.__resetSvcInCollection(that.notice_items_unpaid, data_item);
                            });
                            that.__afterCollectionChanged(that.notice_items_unpaid, that.SVC_TYPES.notice);
                        },
                        onPassengerSelected: function (data, component) {
                            // SELECT SVC ON TOGGLE CARD BUTTON CLICK (https://tracker.flysa.ru/browse/SMA-2290)
                            if (data.hasOwnProperty('force_select')) {
                                that.notice_need_force_select = !data.force_select;
                            }
                        }
                    });
                }
            });
        });
    };

    /**
     * @returns {Boolean} 
     * */
    SvcsScreenOther.prototype.validate = function() {
        var that = this;

        let result = true;

        if (that.insurance_selection) {
            result = that.insurance_selection.validate();
        }

        return result;
    };

    SvcsScreenOther.prototype.__mergeIntoCollection = function (collection_target, collection_source) {
        if (
            !Array.isArray(collection_target) ||
            !Array.isArray(collection_source)
        ) {
            $.sa.error('Error merge collections: some of them is not an array.');
            return [];
        }
        if (!collection_target.length) {
            return collection_source;
        }
        if (!collection_source.length) {
            return collection_target;
        }

        var merged = collection_target.slice();
        collection_source.forEach(function (item_from_source) {
            var is_target_contains = collection_target.some(item_from_target => (
                item_from_source.segment_id.toString()   === item_from_target.segment_id.toString() &&
                item_from_source.passenger_id.toString() === item_from_target.passenger_id.toString() &&
                item_from_source.item_id.toString()      === item_from_target.item_id.toString()
            ));
            if (!is_target_contains) {
                merged.push(item_from_source);
            }
        });
        return merged;
    };

    SvcsScreenOther.prototype.__saveSvcInCollection = function (collection, svc_data) {
        var that = this,
            item_changed_index = collection.findIndex(selection => (
                    selection.segment_id.toString()   === svc_data.segment_id.toString() &&
                    selection.passenger_id.toString() === svc_data.passenger_id.toString() &&
                    selection.item_id.toString()      === svc_data.item_id.toString()
                )
            ),
            quantity = svc_data.item_quantity ? parseInt(svc_data.item_quantity, 10) : 0,
            quantity_prev,
            quantity_diff;

        // if item found, update quantity
        if (item_changed_index !== -1) {
            quantity_prev = collection[item_changed_index]['item_quantity'];
            quantity_diff = quantity - quantity_prev;

            collection[item_changed_index]['item_quantity'] = quantity;
            collection[item_changed_index]['item_quantity_diff'] = quantity_diff;
        }
        // if item wasn't saved yet, save it now
        else {
            quantity_diff = quantity;
            collection.push(svc_data);
        }

        // update quantity_diff in the original data
        that.__afterSvcSelect(Object.assign({}, svc_data, {item_quantity_diff: quantity_diff}));
    };

    SvcsScreenOther.prototype.__resetSvcInCollection = function (collection, svc_data) {
        var that = this,
            item_changed_index = collection.findIndex(selection => (
                    selection.segment_id.toString()   === svc_data.segment_id.toString() &&
                    selection.passenger_id.toString() === svc_data.passenger_id.toString() &&
                    selection.item_id.toString()      === svc_data.item_id.toString()
                )
            ),
            quantity_prev,
            quantity_diff;

        if (item_changed_index === -1) {
            return;
        }

        // if item found, update quantity
        quantity_prev = collection[item_changed_index]['item_quantity'];
        if (quantity_prev <= 0) {
            return;
        }
        quantity_diff = -quantity_prev;

        collection[item_changed_index]['item_quantity'] = 0;
        collection[item_changed_index]['item_quantity_diff'] = quantity_diff;

        // update quantity_diff in the original data
        that.__afterSvcReset(Object.assign({}, svc_data, {item_quantity_diff: quantity_diff}));
    };

    SvcsScreenOther.prototype.__afterSvcSelect = function (svc_data) {
        var that = this,
            svc_quantity_diff = svc_data.item_quantity_diff ? parseInt(svc_data.item_quantity_diff, 10) : 0,
            svc_price = svc_data.item_price ? parseFloat(svc_data.item_price) : 0;

        if (0 !== svc_quantity_diff) {
            that.__changeTotal(svc_price, svc_quantity_diff);
            that.__displayTotal();

            that.onSvcSelected(svc_data, that);

            that.__analiticsEventOnCartChange(svc_data);
        }
    };

    SvcsScreenOther.prototype.__afterSvcReset = function (svc_data) {
        var that = this,
            svc_quantity_diff = svc_data.item_quantity_diff ? parseInt(svc_data.item_quantity_diff, 10) : 0,
            svc_price = svc_data.item_price ? parseFloat(svc_data.item_price) : 0;

        if (0 !== svc_quantity_diff) {
            that.__changeTotal(svc_price, svc_quantity_diff);
            that.__displayTotal();

            that.onSvcReset(svc_data, that);
            
            that.__analiticsEventOnCartChange(svc_data);
        }
    };
    
    SvcsScreenOther.prototype.__analiticsEventOnCartChange = function (data) {
        var that = this;
        if (that.analytics_dataset && that.analytics_dataset.layout === 'main') {
            var cart_change = that.analytics_dataset.svcCartChange(data, that);

            if (cart_change.add_to_cart) {
                $.sa.analytics.gtag('event', 'add_to_cart', cart_change.add_to_cart);
            }

            if (cart_change.remove_from_cart) {
                $.sa.analytics.gtag('event', 'remove_from_cart', cart_change.remove_from_cart);
            }
        }
    }

    /**
     * @param {Object[]} collection Collection of svcs
     * @param {string} collection_svcs_type Type of svcs in specified collection
     * @private
     */
    SvcsScreenOther.prototype.__afterCollectionChanged = function (collection, collection_svcs_type) {
        var that = this;
        that.__showSvcSegmentQtyTotal(collection);
        that.__svcTypeBadgeAddedSet(collection_svcs_type, collection);
        that.__svcTypeSetActionState(collection_svcs_type, collection);
    };

    SvcsScreenOther.prototype.__showSvcSegmentQtyTotal = function (collection) {
        var that = this;

        collection.forEach(function (item) {
            var item_id = item['item_id'].toString(),
                segment_id = item['segment_id'].toString(),
                item_price = parseFloat(item['item_price']),
                quantity,
                price;

            quantity = collection.reduce(function (qty, current) {
                if (
                    current['item_id'].toString() === item_id &&
                    current['segment_id'].toString() === segment_id
                ) {
                    return qty + parseInt(current['item_quantity'], 10);
                } else {
                    return qty;
                }
            }, 0);

            price = item_price * quantity;

            if (quantity > 0) {
                that.__showSvcItemTotal(
                    segment_id,
                    item_id,
                    quantity,
                    price,
                    item['currency']
                );
            } else {
                that.__hideSvcItemTotal(segment_id, item_id);
            }
        });
    };

    /**
     * Toggle (show or hide) badge 'Added' for specified svc, depending on specified state
     * @param {String} type Type of badge. Values: 'added', 'paid'
     * @param {Boolean} state Show or hide badge
     * @param {String|int|null} svc_type If not specified - toggle badges for all svcs on page
     * @private
     */
    SvcsScreenOther.prototype.__svcBadgeToggle = function (type, state, svc_type = null) {
        var that = this,
            $svc = svc_type
                   ? that.$wrapper.find('.' + that.class.svc_card_wrapper + '[data-svc-type=' + svc_type + ']')
                   : that.$wrapper.find('.' + that.class.svc_card_wrapper),
            badge_class = that.class['svc_badge_' + type],
            $svc_badge = $svc.find('.' + badge_class);
        $svc_badge.toggle(state);
    };

    SvcsScreenOther.prototype.__svcBadgeSetQuantity = function (type, svc_type, quantity = 0) {
        var that = this,
            $svc = svc_type
                   ? that.$wrapper.find('.' + that.class.svc_card_wrapper + '[data-svc-type=' + svc_type + ']')
                   : that.$wrapper.find('.' + that.class.svc_card_wrapper),
            badge_class = that.class['svc_badge_' + type],
            $svc_badge = $svc.find('.' + badge_class),
            $svc_badge_quantity = $svc_badge.find('.' + that.class.svc_badge_added_quantity);

        if (!quantity) {
            $svc_badge_quantity.hide();
        } else {
            $svc_badge_quantity.text('x' + quantity).show();
        }
    };

    SvcsScreenOther.prototype.__svcTypeBadgeAddedSet = function (svc_type, items_list) {
        var that = this,
            quantity_all = that.__countItemsQuantity(items_list);

        that.__svcBadgeSetQuantity('added', svc_type, quantity_all);
        that.__svcBadgeToggle('added', !!quantity_all, svc_type);
    };

    SvcsScreenOther.prototype.__svcTypeBadgePaidSet = function (svc_type, items_list) {
        var that = this,
            quantity_all = that.__countItemsQuantity(items_list);

        that.__svcBadgeSetQuantity('paid', svc_type, quantity_all);
        that.__svcBadgeToggle('paid', !!quantity_all, svc_type);
    };

    SvcsScreenOther.prototype.__svcTypeSetActionState = function (svc_type, items_list) {
        var that = this,
            quantity_all = that.__countItemsQuantity(items_list);

        if (quantity_all > 0) {
            that.__svcTypeSetActionStateEdit(svc_type);
        } else {
            that.__svcTypeSetActionStateAdd(svc_type);
        }
    };

    SvcsScreenOther.prototype.__countItemsQuantity = function (items) {
        var quantity = 0;
        items.forEach(function (selection) {
            var item_quantity = selection.hasOwnProperty('item_quantity')
                                ? parseInt(selection.item_quantity, 10)
                                : 0;
            quantity += item_quantity;
        });
        return quantity;
    };

    SvcsScreenOther.prototype.__svcTypeSetActionStateAdd = function (svc_type = null) {
        var that = this,
            $svc = svc_type
                   ? that.$wrapper.find('.' + that.class.svc_card_wrapper + '[data-svc-type="' + svc_type + '"] .' + that.class.svc_type_card)
                   : that.$wrapper.find('.' + that.class.svc_card_wrapper + ' .' + that.class.svc_type_card),
            $svc_action_edit = $svc.find('.' + that.class.svc_action_edit),
            $svc_action_add = $svc.find('.' + that.class.svc_action_add);

        $svc_action_edit.hide();
        $svc_action_add.show();
    };

    SvcsScreenOther.prototype.__svcTypeSetActionStateEdit = function (svc_type) {
        var that = this,
            $svc = that.$wrapper.find('.' + that.class.svc_card_wrapper + '[data-svc-type="' + svc_type + '"] .' + that.class.svc_type_card),
            $svc_action_edit = $svc.find('.' + that.class.svc_action_edit),
            $svc_action_add = $svc.find('.' + that.class.svc_action_add);

        $svc_action_add.hide();
        $svc_action_edit.show();
    };

    SvcsScreenOther.prototype.__showSvcItemTotal = function (segment_id, item_id, quantity, segment_price, currency) {
        var that = this;

        if (!quantity) {
            that.__hideSvcItemTotal(segment_id, item_id);
            return;
        }

        if (!segment_id || (Array.isArray(segment_id) && !segment_id.length) || !item_id || !currency) {
            return;
        }

        var $total_segment = that.$wrapper.find('.' + that.class.svcs_other_total_segment + '[data-segment-id=' + segment_id + ']'),
            $total_item = $total_segment.find('.' + that.class.svcs_other_total_item + '[data-id=' + item_id + ']'),
            $total_item_count = $total_item.find('.' + that.class.svcs_other_total_item_count),
            $total_item_amount = $total_item.find('.' + that.class.svcs_other_total_item_amount),
            segment_price_formatted = $.sa.format.price(parseFloat(segment_price), currency);

        $total_item_count.text('x' + parseInt(quantity, 10));
        $total_item_amount.text(segment_price_formatted);
        $total_item.show();
    }

    SvcsScreenOther.prototype.__hideSvcItemTotal = function (segment_id, item_id) {
        if (!segment_id || !item_id) {
            return;
        }

        var that = this,
            $total_segment = that.$wrapper.find('.' + that.class.svcs_other_total_segment + '[data-segment-id=' + segment_id + ']'),
            $total_item = $total_segment.find('.' + that.class.svcs_other_total_item + '[data-id=' + item_id + ']');

        $total_item.hide();
    };

    SvcsScreenOther.prototype.__changeTotal = function (value, multiplier = 1) {
        value = parseFloat(value);
        multiplier = parseFloat(multiplier);

        var that = this,
            amount = value * multiplier;

        if (amount < 0 && that.total < Math.abs(amount)) {
            $.sa.log('Error count total price');
        } else {
            that.total += amount;
        }
    };

    SvcsScreenOther.prototype.__displayTotal = function () {
        var that = this;

        if (!that.order_currency) {
            return;
        }

        var $total_amount = that.$wrapper.find('.' + that.class.svcs_other_total_amount),
            total_amount_text = $.sa.format.price(that.total, that.order_currency);

        $total_amount.text(total_amount_text);
    };
    
    SvcsScreenOther.prototype.__initMealIncompleteWarning = function (drawer) {
        var that = this;

        if (that.__isMealIncomplete()) {
            that.__renderMealIncompleteWarningModal(drawer);
        } else {
            drawer.close();
        }
    };

    SvcsScreenOther.prototype.__isMealIncomplete = function () {
        var that = this,
            svcs_selected = that.meal_items_unpaid,
            svcs_selected_clear;

        if (that.meal_items_paid.length) {
            svcs_selected = that.meal_items_paid.concat(svcs_selected);
        }

        svcs_selected_clear = PageSvcs.prototype.svcsSelectedCleanSort(svcs_selected);

        if (!svcs_selected_clear.length) {
            return false;
        }

        for(var order_passenger_id of that.order_passengers_ids) {
            var passenger_id = parseInt(order_passenger_id, 10),
                passenger_matched = svcs_selected_clear.findIndex(function (svc_selected) {
                    return parseInt(svc_selected.passenger_id, 10) === passenger_id;
                });

            if (passenger_matched === -1) {
                continue;
            }
            
            // If there is a match by passenger_id in the svcs_selected_clear array,
            // then check is there a match in each segment
            for (var order_segment_id of that.order_segments_ids) {
                var segment_id = parseInt(order_segment_id, 10),
                    segment_matched = svcs_selected_clear.findIndex(function (svc_selected) {
                        return  parseInt(svc_selected.passenger_id, 10) === passenger_id &&
                                parseInt(svc_selected.segment_id, 10) === segment_id;
                    });

                // if segment matched remove object with this segment from array for next loop check
                if (segment_matched !== -1) {
                    svcs_selected_clear.splice(segment_matched, 1);
                }

                if (segment_matched === -1) {
                    return true;
                }
            }
        }

        return false;
    };

    SvcsScreenOther.prototype.__renderMealIncompleteWarningModal = function (drawer) {
        var that = this;
        
        $.uiModal({
            html: that.meal_incomplete_warning_html,
            onButtonCancelClick: function () {
                drawer.close();
            }
        });
    };

    /**
     * @param {String} step
     * @param {String?} next_screen_id
     * @returns {Boolean}
     * */
    SvcsScreenOther.prototype.isRenderedInsuranceEmptyWarningOn = function (step, next_screen_id = null) {
        var that = this;

        if (
            !that.insurance_selection
            && that.insurance_empty_warning_enable
            && !that.insurance_empty_warning_shown
            && (step === 'other' || step === 'submit')
            && that.__isInsuranceEmpty()
        ) {
            that.__renderInsuranceEmptyModal(step, next_screen_id);
            that.__setInsuranceEmptyWarningShown(true);
            return true;
        }
        
        return false;
    };

    SvcsScreenOther.prototype.__isInsuranceEmpty = function () {
        var that = this,
            insurance_items_all = [
                ...that.insurance_items_default,
                ...that.insurance_items_unpaid,
                ...that.insurance_items_paid
            ], 
            insurance_items_all_clear = PageSvcs.prototype.svcsSelectedCleanSort(insurance_items_all);
        
        return !insurance_items_all_clear.length;
    };

    SvcsScreenOther.prototype.__renderInsuranceEmptyModal = function (step, next_screen_id) {
        var that = this;

        $.uiModal({
            html: that.insurance_empty_warning_html,
            onConfirmClosed: function (){
                that.onInsuranceEmptyWarningClose(step, next_screen_id);
            },
            onCancelClosed: function (){
                that.onInsuranceEmptyWarningClose(step, next_screen_id);
            },
            onButtonConfirmClick: function (){
                that.insurance.forceSelect();
                that.insurance['items_unpaid'].forEach(function (item) {
                    that.__saveSvcInCollection(that.insurance_items_unpaid, item);
                });
                that.__afterCollectionChanged(that.insurance_items_unpaid, that.SVC_TYPES.insurance);
            }
        });
    };

    SvcsScreenOther.prototype.__setInsuranceEmptyWarningShown = function (state) {
        var that = this;

        that.insurance_empty_warning_shown = state;
    };

    /**
     * @returns {InsuranceSelection|null}
     */
    SvcsScreenOther.prototype.__getInsuranceSelection = function() {
        var that = this;

        // Если АБ-тест сработает, то в DOM будет присутствовать этот блок
        const $wrapper = that.$wrapper.find('.js-insurance-selection-section');
        if (!$wrapper.length) { return null; }

        // VARS

        const class_names = {
            expanded        : 'is-expanded',
            tooltip_active  : 'is-tooltip-active',
            tooltip_disabled: 'tooltip-disable-self',
            accordion_active: 'is-active',
            selection_unset : 'is-unset'
        };

        const storage_name = 'svsc-others-insurance-selection';

        const $tooltip_wrapper       = $wrapper.find('.js-selection-tooltip-wrapper'),
              $tooltip               = $wrapper.find('.js-selection-tooltip'),
              $selection_wrapper     = $wrapper.find('.js-selection-wrapper'),
              $total                 = $wrapper.find('.js-svcs-insurance-total'),
              $radio_enable          = $wrapper.find('.js-insurance-enable'),
              $radio_disable         = $wrapper.find('.js-insurance-disable'),
              $accordion_item        = $wrapper.find('.js-accordion .js-accordion-item:first'),
              $accordion_item_button = $accordion_item.find('.js-accordion-button');

        let is_insurance_option_selected = false,
            is_insurance_has_unpaid = !!that.insurance_items_unpaid.length;

        // При первом открытии страницы валидируем блок
        validate({ render_errors: true });

        // EVENTS

        // Раскрывашка опций для мобильного вида
        $wrapper.on('click', '.js-toggle-description-options', function() {
            $(this).closest('.description-options').addClass(class_names.expanded);
        });

        // Изменение полей
        $selection_wrapper.on('change', 'input[type="radio"]', function() {
            const value = $(this).val();

            let is_enabled = (value === 'enable');
            if (is_enabled) {
                applyInsurance();
            } else {
                cancelInsurance();
            }

            is_insurance_option_selected = true;

            const storage = JSON.stringify({ selection: is_enabled });
            sessionStorage.setItem(storage_name, storage);

            // Валидация очистит ошибки, если они были показаны
            validate();
        });

        // RETURN

        /**
         * @typedef {Object} InsuranceSelection
         * @property {Function} init - Set insurance selection from storage
         * @property {Function} validate - Validates insurance selection
         * */
        return {
            init,
            validate: function(options) {
                options = (typeof options === 'object' ? options : {
                    render_errors: true,
                    render_tooltip: true,
                    scroll_into_view: true
                });

                return validate(options);
            }
        }

        // FUNCTIONS

        /**
         * @param {Object?}  options
         * @param {Boolean?} options.render_errors
         * @param {Boolean?} options.render_tooltip
         * @param {Boolean?} options.scroll_into_view
         * @returns {Boolean}
         * */
        function validate(options = {}) {
            let { render_errors, render_tooltip, scroll_into_view } = options;

            render_errors = (typeof render_errors === 'boolean' ? render_errors : false);
            render_tooltip = (typeof render_tooltip === 'boolean' ? render_tooltip : false);
            scroll_into_view = (typeof scroll_into_view === 'boolean' ? scroll_into_view : false);

            const accordion_is_active = $accordion_item.hasClass(class_names.accordion_active);

            const is_valid = !!is_insurance_option_selected;
            if (!is_valid ) {
                if (render_errors) {
                    if (!accordion_is_active) {
                        $accordion_item_button.trigger('click');
                    }

                    $selection_wrapper.addClass(class_names.selection_unset);
                    if (render_tooltip) {
                        // Что-то удаляет активный класс на подсказках, 
                        // поэтому проставляем в очереди через таймаут с нулевой задержкой
                        setTimeout( function() {
                            $tooltip_wrapper.addClass(class_names.tooltip_active);
                            $tooltip.removeClass(class_names.tooltip_disabled);
                        }, 0);
                    } else {
                        $tooltip.addClass(class_names.tooltip_disabled);
                    }
                }
                if (scroll_into_view) {
                    $wrapper[0].scrollIntoView({ block: "start", behavior: "smooth" });
                }

            // Если валидно, очищаем ошибки
            } else {
                $selection_wrapper.removeClass(class_names.selection_unset);
                $tooltip_wrapper.removeClass(class_names.tooltip_active);
                $tooltip.addClass(class_names.tooltip_disabled);
            }

            return is_valid;
        }

        function applyInsurance() {
            that.insurance.forceSelect();

            that.insurance.items_unpaid.forEach(function (item) {
                that.__saveSvcInCollection(that.insurance_items_unpaid, item);
            });

            that.__afterCollectionChanged(that.insurance_items_unpaid, that.SVC_TYPES.insurance);

            renderTotal();
        }

        function cancelInsurance() {
            that.insurance.reset();

            that.insurance_items_unpaid.forEach( function(data_item) {
                that.__resetSvcInCollection(that.insurance_items_unpaid, data_item);
            });
            that.__afterCollectionChanged(that.insurance_items_unpaid, that.SVC_TYPES.insurance);

            renderTotal();
        }

        function renderTotal() {
            const insurance_total_html = $.sa.format.price(that.insurance.total, that.order_currency);
            $total.html(insurance_total_html);
        }
        
        function init() {
            if (is_insurance_has_unpaid) {
                $radio_enable.trigger('click');
                is_insurance_has_unpaid = false;

            } else {
                let storage = sessionStorage.getItem(storage_name);
                if (storage) {
                    storage = JSON.parse(storage);
                    if (storage.selection) {
                        $radio_enable.trigger('click');
                    } else {
                        $radio_disable.trigger('click');
                    }
                }
            }
        }
    };

    return SvcsScreenOther;
})($);
